import { State } from '@meraki-internal/state';
import { useEffect, useMemo, useState } from 'react';

// This is a fork that returns TState from the hook instead of IMergedState
type IStateSyncGetter<TState extends State> = (...args: any[]) => TState;

export function useSubscriptionSync<TState extends State>(getState: IStateSyncGetter<TState>, subscriptionKey = 'none'): TState {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const state = useMemo<TState>(getState, [subscriptionKey]);
    const [, setCounter] = useState(1);

    useEffect(() => {

        const unsub = state.subscribe(() => {
            // if we setReactState again, the reference hasn't changed and react will swallow it
            setCounter(count => count+1);
        });

        return () => {
            if (unsub) {
                unsub();
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subscriptionKey]);

    return state;
}
